import { render, staticRenderFns } from "./SecVault.vue?vue&type=template&id=576ccf54&"
import script from "./SecVault.vue?vue&type=script&lang=js&"
export * from "./SecVault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports